const DevView = () => <div>Space dev</div>

export default DevView
